import { render, staticRenderFns } from "./it-svg.vue?vue&type=template&id=a532ff08"
import script from "./it-svg.vue?vue&type=script&lang=js"
export * from "./it-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports